import { Button, Modal } from 'react-bootstrap';

import AuditLogs from '../../pages/Attribute/AuditLogs';
import DiaryHistory from '../../pages/Attribute/DiaryHistory';
import { Radio } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

const ModalDiaryHistory = ({ setShow, show, deviceId, dataDiagram }) => {
  const { t } = useTranslation();

  const optionsLogs = [
    { label: t('activity-log'), value: 'activity-log' },
    { label: t('audit-logs'), value: 'audit-logs' },
  ];

  const [currenLogs, setCurrenLogs] = React.useState('activity-log');
  const handleClose = () => setShow(false);
  const handleSelectLogs = ({ target: { value } }) => {
    setCurrenLogs(value);
  };

  return (
    <Modal onHide={handleClose} show={show} size="xl">
      <Modal.Header closeButton>
        <Radio.Group
          options={optionsLogs}
          onChange={handleSelectLogs}
          value={currenLogs}
          optionType="button"
          buttonStyle="solid"
        />
      </Modal.Header>
      <Modal.Body>
        {currenLogs === 'activity-log' ? (
          <DiaryHistory deviceId={deviceId} dataDiagram={dataDiagram} />
        ) : (
          <AuditLogs deviceId={deviceId} />
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          {t('close')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalDiaryHistory;
